import React, {useEffect, useState} from 'react';
import {Modal, Button, Form, Select, Input, message} from 'antd';
import LocatorList from "./commands/locator/LocatorList";
import {LocateDto} from "../../api";
import {listToLocateDto, locateDtoToList} from "../../utils/LocatorUtils";
import {useSystemContext} from "../../utils/hook/SystemProvider";

const {Option} = Select;

const EditLocateModal = ({visible, initialLocateDtoData, onCancel, onSave}) => {
    const [form] = Form.useForm();
    const [locators, setLocators] = useState<LocateDto[]>([]);
    const { systems, triggerRefresh } = useSystemContext();

    useEffect(() => {
        if(initialLocateDtoData){
            setLocators(locateDtoToList(initialLocateDtoData));
            form.setFieldValue("name", initialLocateDtoData.name);
            form.setFieldValue("system", initialLocateDtoData.system);
        }
    }, [initialLocateDtoData]);

    const setLocatorData = (locateDtoList: LocateDto[]) => {
        setLocators(locateDtoList);
    }

    const handleSave = () => {
        if (!locators || locators.length == 0) {
            message.error("Es muss mindestens ein Locator angegeben werden!");
        } else {
            const name = form.getFieldValue('name');
            const system = form.getFieldValue('system');
            if (!name || !system) {
                message.error("Es muss ein Name und System angegeben werden!");
                return;
            }

            const locateDto: LocateDto = listToLocateDto(locators);
            locateDto.name = name;
            locateDto.system = system;
            form.resetFields();
            setLocators([]);
            onSave(locateDto);
        }
    }


    return (
        <Modal
            open={visible}
            title={"Locator"}
            onCancel={onCancel}
            footer={[
                <Button key="cancel" onClick={onCancel}>
                    Schließen
                </Button>,
                <Button key="save" type="primary" onClick={handleSave}>
                    {initialLocateDtoData ? "Speichern" : "Hinzufügen"}
                </Button>,
            ]}
            width={800}
        >
            <LocatorList locateDtoList={locators} onChange={setLocatorData}/>
            <Form
                form={form}
                layout="vertical"
            >
                <Form.Item name="system" label="System-Option" rules={[{required: true}]}>
                    <Select
                        placeholder="Wähle ein System aus"
                        allowClear
                    >
                        {systems.map(option => (
                            <Option key={option.id} value={option.id}>
                                {option.name}
                            </Option>
                        ))}
                    </Select>
                </Form.Item>
                <Form.Item name="name" label="Locator-Name" rules={[{required: true}]}>
                    <Input/>
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default EditLocateModal;